import { useDispatch, useSelector } from "react-redux";
import { ChevronUp, Download, X } from "lucide-react";
import { IconButton } from "@mui/material";
import { motion } from "framer-motion";
import { useMemo, memo } from "react";
import { Dispatch } from "redux";

// A S S E T S
import LogoAltaEspecialidad from "../../assets/images/logo_alta_especialidad.png";
import LogoDefault from "../../assets/images/logo_base_muguerza.png";
import LogoSaltillo from "../../assets/images/logo_saltillo.png";
import LogoConchita from "../../assets/images/logo_conchita.svg";
import LogoCumbres from "../../assets/images/logo_cumbres.png";

// U T I L S
import { AppState, setHeaderState, setPageState, setTriggerDownloadPDF } from "../../store/reducer";
import { HeaderState, transition, variantsButtons, variantsLogo } from "./HeaderUtils";
import { PageState } from "../../views/Home/HomeUtils";
import { LoggedUser } from "../../store/interfaces";

/**
 * Obtiene la ubicación del logo
 * @param assignedHospitals Lista de hospitales del usuario
 * @returns Un string de al ubicación del logo
 */
const getLogoHospital = (assignedHospitals: string[]) => {
	if (assignedHospitals.length > 1) return LogoDefault;
	if (assignedHospitals.includes("Cumbres")) return LogoCumbres;
	if (assignedHospitals.includes("Saltillo")) return LogoSaltillo;
	if (assignedHospitals.includes("Alta Especialidad")) return LogoAltaEspecialidad;
	if (assignedHospitals.includes("Conchita")) return LogoConchita;
	return LogoDefault;
};

function HeaderRight() {
	const assignedhospitals: string[] = useSelector(
		(state: AppState) => state.loggedUser,
	).assigned_hospitals;
	const state: HeaderState = useSelector((state: AppState) => state.headerState);
	const isDownloadPDFButtonEnable: boolean = useSelector(
		(state: AppState) => state.isDownloadPDFButtonEnable,
	);
	const previousPageState: PageState = useSelector((state: AppState) => state.previousPageState);

	const dispatch: Dispatch<any> = useDispatch();

	const currentLogo: string = useMemo(
		() => getLogoHospital(assignedhospitals),
		[assignedhospitals],
	);

	const _onChangeToPreviousPageState = () => {
		dispatch(setHeaderState(HeaderState.Normal));
		dispatch(setPageState(previousPageState));
	};

	if (state === HeaderState.Normal) {
		return (
			<motion.div
				key={"Logo"}
				transition={transition}
				variants={variantsLogo}
				initial="initial"
				animate="visible"
				exit="exit"
			>
				<img
					src={currentLogo}
					className="header__logo"
				></img>
			</motion.div>
		);
	}
	if (state === HeaderState.Extended || state === HeaderState.Collapse) {
		return (
			<motion.div
				key={"Buttons"}
				transition={transition}
				variants={variantsButtons}
				initial="initial"
				animate="visible"
				exit="exit"
			>
				<IconButton
					className="header__button"
					disabled={!isDownloadPDFButtonEnable}
					onClick={() => dispatch(setTriggerDownloadPDF(true))}
				>
					<Download />
				</IconButton>
				<IconButton
					className="header__button"
					onClick={() => {
						dispatch(
							setHeaderState(
								state === HeaderState.Extended
									? HeaderState.Collapse
									: HeaderState.Extended,
							),
						);
					}}
				>
					<motion.div
						style={{ height: "24px" }}
						animate={
							state === HeaderState.Collapse
								? { transform: "rotateX(180deg)" }
								: { transform: "rotateX(0deg)" }
						}
						transition={transition}
					>
						<ChevronUp />
					</motion.div>
				</IconButton>
				<IconButton
					className="header__button"
					onClick={_onChangeToPreviousPageState}
				>
					<X />
				</IconButton>
			</motion.div>
		);
	}

	return null;
}

export default memo(HeaderRight);
